import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';

import {GrowlService, UserService} from '@app/core';

import {DocFile} from '@app/shared/classes/doc-file';
import {DocumentType} from '@app/shared/enums/document-type.enum';
import {CommonDocRepoService} from '@app/shared/services/common-doc-repo.service';
import {Validation} from "@app/shared/enums/validation.enum";
import {FileUpload} from "primeng/fileupload/fileupload";

/**
 * @author Jin Chun (October 12th, 2018)
 * @desc shared component to select a file and returns the data in the DocFile type; selected file's data is stored
 *        as bytearray in the DocFile.docData.data
 */

@Component({
  selector: 'app-file-load',
  templateUrl: './file-load.component.html',
  styleUrls: ['./file-load.component.css']
})
export class FileLoadComponent implements OnInit, OnChanges {

  @Input() fileName: string;                                                // the fileName will replace the name of selected file
  @Input() docType: DocumentType;                                           // specified doc type to set for the returned docFile
  @Input() docTypeId: number;                                               // specified doc type id to set for the returned docFile
  @Input() chooseLabel: string;                                             // configurable label for file selection e.g. New Resume vs. Update Resume
  @Input() fileType: string;                                                // specific file type to select
  @Input() styleClass: string;
  @Input() maxFileSize: number;                                             // maximum acceptable file size

  @Output() loadHandler: EventEmitter<DocFile> = new EventEmitter();        // handler returning selected file in DocFile object

  MaxFileSize: number;                                                      // max file size supported by backend; if changed, make sure to change the backend as well as nginx configuration

  // allow pdf, text, microsoft, text and image files for upload
  AcceptableFileType = "text/*, image/*, application/pdf, application/rtf, application/x-rtf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/vnd.openxmlformats-officedocument.presentationml.template, application/vnd.oasis.opendocument.text";

  docFile: DocFile = new DocFile();             // file to be uploaded, set only when displayMode == FileExplorerDisplay.Dialog

  @ViewChild('fileUpload') fileUpload: FileUpload;

  constructor(private dataService: CommonDocRepoService, public user: UserService, private growl: GrowlService) {
  }

  /**
   * @desc
   */
  ngOnChanges(changes: SimpleChanges): void {
    console.log(`file-load ngOnChanges: fileName=${this.fileName}  documentType=${this.docType} styleClass=${this.styleClass}`);

    if (!this.chooseLabel) {
      this.chooseLabel = "Select File";
    }
    if (!this.fileType) {
      this.fileType = this.AcceptableFileType;
    }
    if (!this.styleClass) {
      this.styleClass = "action-secondary";
    }
    if (!this.maxFileSize) {
      this.maxFileSize = Validation.MaxFileSize;
    }
    console.log(`file-load ngOnChanges: fileName=${this.fileName}  documentType=${this.docType} styleClass=${this.styleClass}`);
  }

  ngOnInit() {
  }

  /**
   * @desc load the selected file (event.files[0]) to the data table
   * @returns: this.docFiles - a new file (event.files[0]) added to this array
   */
  onSelectBrowseFile(files: File[]): void {
    const selectedFileToLoad: File = files[0];

    if (selectedFileToLoad && selectedFileToLoad.size > this.maxFileSize) {
      if (this.maxFileSize > 1000000) {
        this.growl.add("warn", `The file is too large. It has to be less than ${(this.maxFileSize / 1000000).toFixed(0)} megabytes.`);
      } else {
        this.growl.add("warn", `The file is too large. It has to be less than ${(this.maxFileSize / 1000).toFixed(0)} kilobytes.`);
      }
      return;
    }

    this.docFile.fileName = (this.fileName == null ? selectedFileToLoad.name : this.fileName);
    this.docFile.mimeType = selectedFileToLoad.type;

    // load the file as bytearray
    this.dataService.loadFileData(selectedFileToLoad).subscribe(data => {
      this.docFile.data = data;
      this.loadHandler.emit(this.docFile);
    });
  }

  /**
   * this is called automatically based [auto]="true", need to clear the fileUpload so it can be replaced.
   * @param event
   */
  handleUpload(): void {
    this.fileUpload.clear();
  }
}
